import { MisaInward, MisaInwardDetail, PrintInfo } from "../types/misa";
import { generatePrintHTMLNhapKho } from "../utils/generatePrintHTMLNhapKho";

const SKU_LOCATION_SHEET_URL =
  "https://docs.google.com/spreadsheets/d/1eec7Nc7X2kMohpCLJjurOUcNuDu89OpNPDRg4yXdq0c/export?format=csv&gid=0";

const fetchSkuLocations = async (): Promise<Map<string, string>> => {
  try {
    const response = await fetch(SKU_LOCATION_SHEET_URL);
    if (!response.ok) return new Map();

    let csvText = await response.text();
    csvText = csvText.replace(/^\uFEFF/, ""); // Remove BOM if present
    const lines = csvText.split(/\r?\n/);
    const locationMap = new Map<string, string>();

    // Skip header row, parse CSV: Column B (Mã SKU) và Column D (Vị trí trong Kho)
    // Sử dụng regex để tách cột, giữ nguyên chuỗi trong dấu ngoặc kép
    const parseCSVLine = (line: string): string[] => {
      const result: string[] = [];
      let current = "";
      let inQuotes = false;
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === "," && !inQuotes) {
          result.push(current);
          current = "";
        } else {
          current += char;
        }
      }
      result.push(current);
      return result;
    };

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;

      const columns = parseCSVLine(line);
      if (columns.length >= 4) {
        const skuCode = columns[1].replace(/^['"]|['"]$/g, "").trim(); // Column B (index 1)
        const location = columns[3].replace(/^['"]|['"]$/g, "").trim(); // Column D (index 3)
        if (skuCode && location) {
          locationMap.set(skuCode, location);
        }
      }
    }

    return locationMap;
  } catch (error) {
    console.error("Error fetching SKU locations:", error);
    return new Map();
  }
};

export const printPhieuNhapKho = async (
  row: MisaInward,
  details: MisaInwardDetail[],
  inventorries?: any[]
): Promise<void> => {
  const skuLocations = await fetchSkuLocations();

  // Sắp xếp details theo vị trí, ưu tiên vị trí bắt đầu bằng 'A' lên trước
  // So sánh vị trí dạng A-3-9, A-3-15 theo số học
  function compareLocation(a: string, b: string): number {
    const splitA = a
      .split(/[-_]/)
      .map((x) => (isNaN(Number(x)) ? x : Number(x)));
    const splitB = b
      .split(/[-_]/)
      .map((x) => (isNaN(Number(x)) ? x : Number(x)));
    for (let i = 0; i < Math.max(splitA.length, splitB.length); i++) {
      if (splitA[i] === undefined) return -1;
      if (splitB[i] === undefined) return 1;
      if (typeof splitA[i] === "number" && typeof splitB[i] === "number") {
        if (splitA[i] !== splitB[i])
          return Number(splitA[i]) - Number(splitB[i]);
      } else {
        const cmp = String(splitA[i]).localeCompare(String(splitB[i]), "vi");
        if (cmp !== 0) return cmp;
      }
    }
    return 0;
  }

  const sortedDetails = [...details].sort((a, b) => {
    const nameA = (a as any).InventoryItemName || "";
    const nameB = (b as any).InventoryItemName || "";
    return nameA.localeCompare(nameB, "vi", { sensitivity: "base" });
  });

  // const sortedDetails = [...details].sort((a, b) => {
  //   const locA = skuLocations.get(a.SKUCode || "") || "";
  //   const locB = skuLocations.get(b.SKUCode || "") || "";
  //   // Đẩy mục không có vị trí xuống dưới cùng
  //   if (!locA && locB) return 1;
  //   if (locA && !locB) return -1;
  //   if (!locA && !locB) return 0;
  //   // Ưu tiên vị trí bắt đầu bằng 'A'
  //   const isA_A = locA.startsWith("A");
  //   const isB_A = locB.startsWith("A");
  //   if (isA_A && !isB_A) return -1;
  //   if (!isA_A && isB_A) return 1;
  //   // So sánh vị trí dạng A-3-9, A-3-15 theo số học
  //   return compareLocation(locA, locB);
  // });

  const printInfo: PrintInfo = {
    header: row,
    details: sortedDetails,
    currentDate: new Date().toLocaleDateString("vi-VN"),
    skuLocations,
    inventorries,
  };

  const printContent = generatePrintHTMLNhapKho(printInfo);
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.left = "-999px";
  iframe.style.top = "-999px";
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument || iframe.contentWindow?.document;
  if (!doc) return;

  doc.open();
  doc.write(printContent);
  doc.close();

  setTimeout(() => {
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();
    setTimeout(() => document.body.removeChild(iframe), 1000);
  }, 500);
};
